/**
=========================================================
* Material Dashboard 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "App";
import { Provider } from "react-redux";
import { MaterialUIControllerProvider } from "context/index";
import { ToastContainer } from "react-toastify";
import store from "./store";
import "react-toastify/dist/ReactToastify.css";
import "./i18n";
import "moment/locale/es";

// Soft UI Context Provider

ReactDOM.render(
  <Router>
    <MaterialUIControllerProvider>
      <Provider store={store}>
        <App />
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Provider>
    </MaterialUIControllerProvider>
  </Router>,
  document.getElementById("root")
);
